export default theme => ({
  root: {
    margin: '0 auto',
    width: 1160,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut,
    }),
    [theme.breakpoints.only('md')]: {
      width: 760
    },
    [theme.breakpoints.only('sm')]: {
      width: '90%'
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing.unit * 2,
      paddingLeft: theme.spacing.unit * 2,
      width: '100%'
    }
  },
  gutterTop: {
    paddingTop: theme.spacing.unit * 5
  },
  gutterBottom: {
    paddingBottom: theme.spacing.unit * 5
  }
});



// WEBPACK FOOTER //
// ./src/atoms/Container/styles.js